/**
 * @generated SignedSource<<c987712b9fc2d82b21198157dea3c274>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type defaultPagesSeoPage$data = {
  readonly headline: string | null | undefined;
  readonly urlAlias: string;
  readonly " $fragmentType": "defaultPagesSeoPage";
};
export type defaultPagesSeoPage$key = {
  readonly " $data"?: defaultPagesSeoPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"defaultPagesSeoPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "defaultPagesSeoPage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "headline",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urlAlias",
      "storageKey": null
    }
  ],
  "type": "Page",
  "abstractKey": null
};

(node as any).hash = "ad20dbec112477c9e20541f79049bc4c";

export default node;
